"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = require("react");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const ARROW_DOWN_KEY = 40;
const ARROW_UP_KEY = 38;
const ENTER_KEY = 13;
const ESCAPE_KEY = 27;
function useKeyboardSelect(options, config = {}) {
    const { focused = true, onSelectItem = noop_1.default, onOpenOptions = noop_1.default, onCloseOptions = noop_1.default, showOptions = true, } = config;
    const [selectedItem, setSelectedItem] = (0, libs_hooks_react_1.useReferencedState)(null);
    const optionsRef = (0, libs_hooks_react_1.useSelfUpdatingRef)(options);
    const showOptionsRef = (0, libs_hooks_react_1.useSelfUpdatingRef)(showOptions);
    // Keyboard Events
    (0, react_1.useEffect)(function keyPressEffect() {
        const length = options.length;
        const enable = focused && !!length;
        if (!enable) {
            // Reset selected item
            setSelectedItem(null);
            return;
        }
        function onKeyDown(event) {
            const { keyCode } = event;
            const optionsCurrent = optionsRef.current;
            let currentIndex = -1;
            if (selectedItem.current) {
                currentIndex = optionsCurrent.indexOf(selectedItem.current);
            }
            let nextItem;
            switch (keyCode) {
                case ARROW_DOWN_KEY:
                    if (currentIndex >= 0) {
                        nextItem = optionsCurrent[currentIndex + 1] || null;
                    }
                    else {
                        nextItem = optionsCurrent[0];
                    }
                    setSelectedItem(nextItem);
                    if (nextItem) {
                        onOpenOptions();
                    }
                    else {
                        onCloseOptions();
                    }
                    event.preventDefault(); // Prevents the cursor from moving
                    break;
                case ARROW_UP_KEY:
                    if (currentIndex === 0) {
                        nextItem = null;
                    }
                    else if (currentIndex === -1) {
                        nextItem = optionsCurrent[optionsCurrent.length - 1];
                    }
                    else {
                        nextItem = optionsCurrent[currentIndex - 1] || null;
                    }
                    setSelectedItem(nextItem);
                    if (nextItem) {
                        onOpenOptions();
                    }
                    else {
                        onCloseOptions();
                    }
                    event.preventDefault(); // Prevents the cursor from moving
                    break;
                case ENTER_KEY: {
                    // See #388
                    if (event.keyCode === 229) {
                        break;
                    }
                    if (selectedItem.current) {
                        onSelectItem(selectedItem.current);
                        event.preventDefault();
                    }
                    break;
                }
                case ESCAPE_KEY: {
                    if (showOptionsRef.current) {
                        setSelectedItem(null);
                        onCloseOptions();
                        // when Escape is pressed. We want to disable this default
                        // behaviour so that, when suggestions are shown, we just hide
                        // them, without clearing the input.
                        event.preventDefault();
                    }
                    break;
                }
            }
        }
        document.addEventListener('keydown', onKeyDown);
        return function cleanListenersUp() {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onSelectItem, focused, options]);
    return {
        selectedItem,
    };
}
exports.default = useKeyboardSelect;
//# sourceMappingURL=useKeyboardSelect.js.map